export default {
    results: '     <h4>Import results</h4>' +
        '<p CLASS="mt-3">Mass import has been completed successfully. </p>' +
        '<P>The results are summed up below:</P>' +
        '<ul>' +
        '<li>Total clients: {total}</li>' +
        '<li>New clients: {imported}</li>' +
        '<li>Existing clients: {duplicates}</li>' +
        '</ul>',
    guide: {
        intro: 'Import your clients in bulk by uploading a CSV file (for example, from Excel) with the columns below.',
        required: 'Required',
        columns: {
            firstName: 'The client\'s first name',
            lastName: 'The client\'s last name',
            email: 'Used to recognise clients you already have',
            birthDate: 'As DD/MM/YYYY, e.g. 25/03/1990',
            sex: 'M for male, F for female',
            mobileNum: 'E.g. 6912345678',
            sessionCost: 'Amount in €, e.g. 40 or 40.50',
        },
        notes: {
            headers: 'Headers can be in Greek or English, in any order. Leave out anything you don\'t have.',
            allOrNothing: 'If any row has a mistake, no clients are added and you\'ll see which rows need fixing.',
            duplicates: 'Clients you already have are skipped: same email or, for rows without an email, same full name.',
        },
        template: 'Download the template',
        safari: 'If the download doesn\'t start in Safari, try Google Chrome.',
    },
    errors: {
        title: 'No clients were added',
        invalid: 'We found {count} problem in the file. Fix it and upload the file again. | We found {count} problems in the file. Fix them and upload the file again.',
        row: 'Row {row}',
        more: '…and {count} more',
        retry: 'Upload the fixed file',
        fields: {
            firstName: 'First name',
            lastName: 'Last name',
            email: 'Email',
            birthDate: 'Birth date',
            sex: 'Gender',
            mobileNum: 'Mobile',
            sessionCost: 'Session cost',
        },
        codes: {
            REQUIRED: 'is required',
            INVALID_EMAIL: 'is not a valid email',
            INVALID_DATE: 'is not a valid date; write it as DD/MM/YYYY',
            DATE_OUT_OF_RANGE: 'must be between 1900 and today',
            INVALID_GENDER: 'type M for male or F for female',
            PHONE_SCIENTIFIC_NOTATION: 'Excel turned it into "6.91E+09". Format the column as text and type the number again',
            INVALID_COST: 'is not a valid amount',
        },
        file: {
            CSV_IMPORT_EMPTY: 'The file has no clients in it.',
            CSV_IMPORT_TOO_MANY_ROWS: 'The file has {total} clients. You can import up to {maxRows} at a time, so split it into smaller files.',
            CSV_IMPORT_NO_FILE: 'Please upload a .csv file.',
            quota_exceeded: 'You already have {current} of the {limit} clients your account allows, so the clients in this file don\'t fit.',
            tooBig: 'The file is too large. The limit is 1MB.',
            generic: 'Something went wrong with the file. Please try again.',
        },
    },
}
